<div class="d-flex flex-column bg-login m-0">
  <div class="w-40 mx-auto">
    <div class="card px-2">
      <div class="card-header text-center">
        <div class="mx-auto logo-login mb-4"></div>
        <h5 class="mb-1">{{ "DCO.LogOut_LogOut_Title" | translate }}</h5>
        <p class="text-muted">{{ "DCO.LogOut_LogOut_Message" | translate
          }}<!-- se ha desconectado debe volvera  realizar el proceso de login --></p>
      </div>
      <div class="card-body">
          <div class="alert alert-info" role="alert">
              {{ "DCO.LogOut_LogOut_Flow" | translate }} 
              <br/>
              <a href="{{ logOutUrl }}">{{ logOutUrl }}</a>
              
          </div>
      </div>
    </div>
  </div>
</div>